<template>
  <v-card flat>
    <DialogNotice ref="dlg"></DialogNotice>
    <v-card-text style="padding: 0px;margin: 0px;">
      <v-layout row wrap>
        <v-flex md12>
          <span>&nbsp;</span>
          <v-layout wrap justify-start>
            <v-flex xs12 justify-start>
            <span v-if="missingRight">
              {{'TAB_BR_REPORT_MISSING_RIGHT' | translate}}
            </span>
            </v-flex>
            <v-flex xs12 v-if="!missingRight" justify-start style="text-align: left">
              <v-btn @click="reCreateAX()" class="text-none" color="#004884" small outline>{{'BTN_CREATE_NEW_AX'| translate}}</v-btn>
            </v-flex>
            <v-flex xs12 v-if="!missingRight" justify-start style="text-align: left; border: 1px; color:#5d615d;" class="pl-2">
              <v-icon>feedback</v-icon> {{'BILKO_MESSAGE' | translate}}
              <!-- campaign / priority_high -->
            </v-flex>
            <v-flex xs12 v-if="!missingRight" justify-start class="pl-2">
              <v-btn v-if="axData.success && mdText" @click="downloadAsWord()" class="text-none" color="#004884" small outline>{{'BTN_DOWNLOAD_AX_WORD'| translate}}</v-btn>
            </v-flex>
            <v-flex xs12 v-if="!missingRight" justify-start class="pl-2" :key="kIndex">
              <vue-markdown v-if="axData.success && mdText" style="text-align: left">{{mdText}}</vue-markdown>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
  import Vue from "vue";
  import VueMarkdown from 'vue-markdown'
  import DialogNotice from "../dialogs/DialogNotice";
  export default {
    name: 'TabBilko',
    props: ['balance'],
    components: {DialogNotice, VueMarkdown},
    data() {
      return {
        kIndex: 0,
        axData: {
          success: true,
          kIndex: 0,
          mdText: '',
        },
        missingRight: false,
        panel: null,
        mdText: '',
        isBanks: false
      }
    },
    methods: {
      open: function () {
        Vue.prototype.$eventHub.$emit('OnGetExcelConfig', this.configExcel)
        this.reload()
        this.panel = [true, true]
      },
      onGetAXData: function (axData) {
        Vue.prototype.$api.hideIdle()
        this.axData = axData
        this.mdText = axData.mdText
        this.kIndex++
      },
      downloadAsWord: function () {
        console.log('downloadAsWord')
        let cmp = this
        if (!Vue.prototype.$api.hasProduct('hasRightExport')) {
          Vue.prototype.$api.debug('missing right to export files')
          this.$refs.dlg.show({
            title: Vue.i18n.translate('DIALOG_TITLE_MISSING_HAS_EXPORT'),
            text: Vue.i18n.translate('DIALOG_TEXT_MISSING_HAS_EXPORT')
          })
          return
        }

        Vue.prototype.$api.exportAXToDoc({
          fileName: Vue.i18n.translate('PDF_AX_WORD_FILENAME'),
          balance: cmp.balance,
        }, this.onDocDone)
      },
      onDocDone: function (res) {
        console.log('onDocDone', res)
      },
      reCreateAX: function () {
        console.log('reCreateAX')
        Vue.prototype.$api.showIdle()
        Vue.prototype.$api.getAXSemantics(this.balance, true, this.onGetAXData)
      },
      reload: function () {
        this.mdText = ''
        Vue.prototype.$api.showIdle()
        this.isBanks = (Vue.prototype.$api.getModuleId() === 'banks')
        if (this.isBanks) {
          if (Vue.prototype.$api.hasProduct('bilkoBank')) {
            this.missingRight = false
            Vue.prototype.$api.getAXSemantics(this.balance, false, this.onGetAXData)
          }
        } else {
          if (Vue.prototype.$api.hasProduct('bilko')) {
            this.missingRight = false
            Vue.prototype.$api.getAXSemantics(this.balance, false, this.onGetAXData)
          }
        }
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabBilko.vue